// brand
import LOGO from "./brand/logo_fThings.svg";

// cont
import GRAPHIC_BG from "./cont/graphic_bg.png";
import HOME_ICON from "./cont/home_icon.svg";
import FISH_ICON from "./cont/fish_icon.svg";
import EYE_ICON from "./cont/eye_icon.svg";
import PENCIL_SQUARE_ICON from "./cont/pencil_square_icon.svg";
import TRASH_ICON from "./cont/trash_icon.svg";
import CLIP_ICON from "./cont/clip_icon.svg";
import STATE_ON_ICON from "./cont/state_on_icon.svg";
import STATE_OFF_ICON from "./cont/state_off_icon.svg";
import COG_ICON from "./cont/cog_icon.svg";
import HAMBURGER_ICON from "./cont/hamburger_icon.svg";
import USER_ICON from "./cont/user_icon.svg";
import LOCK_ICON from "./cont/lock_icon.svg";
import CHEVRON_RIGHT_ICON from "./cont/chevron_right_icon.svg";
import CHECK_ICON from "./cont/check_icon.svg";
import ARROW_LEFT_ICON from "./cont/arrow_left_icon.svg";

const IMG = {
    GRAPHIC_BG,
    HOME_ICON,
    FISH_ICON,
    EYE_ICON,
    PENCIL_SQUARE_ICON,
    TRASH_ICON,
    CLIP_ICON,
    STATE_ON_ICON,
    STATE_OFF_ICON,
    COG_ICON,
    HAMBURGER_ICON,
    USER_ICON,
    LOCK_ICON,
    CHEVRON_RIGHT_ICON,
    CHECK_ICON,
    ARROW_LEFT_ICON,
    LOGO
};

export default IMG;